<sf-page-action-bar>
    <button sfButton size="md" color="success" icon="floppy-disk" (click)="saveSmartQuote()">Save Quote</button>
</sf-page-action-bar>

@if (smartquoteId()) {
    <sf-page-presence-indicator [pageName]="'SmartQuoteEdit'" [entityId]="smartquoteId()!" />
}

<sf-smartquote-top-bar-2
    [smartquote]="existingSmartQuote()"
    [totalCost]="statistics().totalIncludeVat"
    [totalExVatCost]="statistics().totalExcludeVat"
    [deposit]="statistics().depositTotal"
    [smartquote]="existingSmartQuote()"
    [email]="this.form.get('emailAddress')?.value"
    [landingPageUrl]="landingPageUrl()"
    [canOrderFromWolseley]="doAllLineItemsHaveCatalogNumbers"
    [productCodes]="catalogCodes()"
    (onAccepted)="acceptQuote()"
    (onDeclined)="declineQuote()"
    (onCopy)="copyQuote()"
    (onDeleted)="deleteQuote()"></sf-smartquote-top-bar-2>

<div class="row mb-5">
    <div class="col-12">
        <sf-smartquote-details
            [form]="form"
            [smartQuoteTemplates]="smartQuoteTemplates()"
            [gcNumber]="mainAppliance()?.gcnumber ?? null"
            [markup]="markup()"
            (lineAdded)="loadWolseleyTerms()"
            (changeDefaultImageUrl)="setDefaultImageUrl($event)">
        </sf-smartquote-details>
    </div>
</div>

<ng-template #awaitingorderModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Awaiting Order</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p class="fw-bold">The quote has been accepted and has a scheduled appointment.</p>
        <p>Don't forget to send the order to a supplier or place the order direct with Wolseley.</p>
    </div>
    <div class="modal-footer">
        <button sfButton type="button" color="dark" (click)="modal.close('')">Close</button>
    </div>
</ng-template>
